const getFacebookShareUrl = (language, state) => {
    const pageUrl = new URL(process.env.REACT_APP_API_HOST);
    pageUrl.searchParams.set('lang', language);
    if (state) {
        pageUrl.searchParams.set('state', state);
    }

    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        pageUrl.toString(),
    )}`;
};

export default getFacebookShareUrl;
